import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useStore } from "../../app/stores/rootStore";

export default observer(function UserDashboard() {
    const { bookingStore, wishlistStore,cartStore, userStore: { user } } = useStore();
    const [activeTab, setActiveTab] = useState<'orders' | 'wishlist'>('orders');

    useEffect(() => {
        if (user?.uid) {
            bookingStore.loadAll(user.uid, "userId");
            wishlistStore.syncWishlist(user.uid);
        }
    }, [user, bookingStore, wishlistStore]);

    const handleCancelOrder = async (orderId: string) => {
        if (window.confirm("Are you sure you want to cancel this order?")) {
            await bookingStore.manage(orderId, { status: 'Cancelled' } as any);
        }
    };

    return (
        <section className="header1 cid-uATOSlQKYb py-5">
            <div className="container mt-5">
                <div className="row g-4">
                    {/* Sidebar Navigation */}
                    <div className="col-lg-3">
                        <div className="card border-0 shadow-sm p-4 bg-white rounded-4">
                            <div className="text-center mb-4">
                                <div className="bg-primary-subtle rounded-circle p-3 d-inline-block mb-3">
                                    <i className="bi bi-person-circle h2 text-primary"></i>
                                </div>
                                <h5 className="fw-bold mb-0">{user?.name || "User"}</h5>
                                <p className="text-muted small">{user?.email}</p>
                            </div>
                            <ul className="nav flex-column gap-2 no-print">
                                <li className="nav-item">
                                    <button className={`nav-link w-100 text-start rounded-3 px-3 py-2 border-0 ${activeTab === 'orders' ? 'bg-primary text-white' : 'bg-transparent text-dark'}`} 
                                            onClick={() => setActiveTab('orders')}>
                                        <i className="bi bi-bag-check me-2"></i> My Orders
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button className={`nav-link w-100 text-start rounded-3 px-3 py-2 border-0 ${activeTab === 'wishlist' ? 'bg-primary text-white' : 'bg-transparent text-dark'}`} 
                                            onClick={() => setActiveTab('wishlist')}>
                                        <i className="bi bi-heart me-2"></i> Wishlist
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                    {/* Main Content Area */}
                    <div className="col-lg-9">
                        <div className="card border-0 shadow-sm p-4 bg-white rounded-4 min-vh-50">
                            {activeTab === 'orders' ? (
                                <>
                                    <h4 className="fw-bold mb-4">Order History</h4>
                                    {bookingStore.items.length === 0 ? (
                                        <div className="text-center py-5">No orders found.</div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table align-middle">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Receipt #</th>
                                                        <th>Date</th>
                                                        <th>Total</th>
                                                        <th>Status</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {bookingStore.items.map(order => (
                                                        <tr key={order.id}>
                                                            <td className="fw-bold">{order.receiptNumber}</td>
                                                            <td className="small">{new Date(order.orderDate?.seconds * 1000).toLocaleDateString()}</td>
                                                            <td>Rs. {order.total.toLocaleString()}</td>
                                                            <td>
                                                                <span className={`badge rounded-pill ${order.status === 'Cancelled' ? 'bg-danger-subtle text-danger' : 'bg-success-subtle text-success'}`}>
                                                                    {order.status}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                {order.status !== 'Cancelled' && (
                                                                    <button className="btn btn-outline-danger btn-sm" 
                                                                            onClick={() => handleCancelOrder(order.id!)}>
                                                                        Cancel
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <>
                                    <h4 className="fw-bold mb-4">Saved in Wishlist</h4>
                                    {/* <div className="row g-3">
                                        {wishlistStore.items.map(item => (
                                            <div className="col-md-6" key={item.id}>
                                                <div className="d-flex align-items-center border rounded-3 p-2">
                                                    <img src={item.mainImageUrl} alt="" className="rounded" style={{width: '60px', height: '60px', objectFit: 'cover'}} />
                                                    <div className="ms-3 flex-grow-1">
                                                        <h6 className="mb-0 fw-bold">{item.title}</h6>
                                                        <p className="mb-0 small text-primary">Rs. {item.productPrice.toLocaleString()}</p>
                                                    </div>
                                                    <button className="btn btn-sm text-danger" onClick={() => wishlistStore.toggleWishlist(user?.uid, item as any)}>
                                                        <i className="bi bi-trash"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        ))}
                                    </div> */}
                                    <div className="row g-4">
    {wishlistStore.items.map((item) => (
        <div className="col-md-6 col-xl-4" key={item.id}>
            <div className="card h-100 border-0 shadow-sm rounded-4 overflow-hidden position-relative hover-shadow-transition">
                {/* --- Remove Button (Floating) --- */}
                <button 
                    className="btn btn-light btn-sm position-absolute top-0 end-0 m-2 rounded-circle shadow-sm"
                    style={{ zIndex: 2, width: '32px', height: '32px', padding: 0 }}
                    onClick={() => wishlistStore.toggleWishlist(user?.uid, item as any)}
                    title="Remove from wishlist"
                >
                    <i className="bi bi-x-lg small"></i>
                </button>

                <div className="row g-0 h-100">
                    {/* --- Image Section --- */}
                    <div className="col-4">
                        <img 
                            src={item.mainImageUrl} 
                            alt={item.title} 
                            className="img-fluid h-100" 
                            style={{ objectFit: 'cover', minHeight: '120px' }} 
                        />
                    </div>

                    {/* --- Content Section --- */}
                    <div className="col-8 d-flex flex-column">
                        <div className="card-body p-3">
                            <div className="mb-1">
                                <span className="badge bg-primary-subtle text-primary small fw-normal">
                                    {item.brand}
                                </span>
                            </div>
                            <h6 className="card-title fw-bold text-truncate mb-1" title={item.title}>
                                {item.title}
                            </h6>
                            <div className="d-flex align-items-center gap-2 mb-3">
                                <span className="text-danger fw-bold">
                                    Rs. {item.productPrice.toLocaleString()}
                                </span>
                                {item.productStrikePrice > item.productPrice && (
                                    <span className="text-muted small text-decoration-line-through">
                                        Rs. {item.productStrikePrice.toLocaleString()}
                                    </span>
                                )}
                            </div>
                            
                            {/* --- Quick Add to Cart --- */}
                            <button 
                                className="btn btn-outline-primary btn-sm rounded-pill w-100 mt-auto fw-bold"
                                onClick={() => cartStore.addToCart(user?.uid, item as any)}
                            >
                                <i className="bi bi-cart-plus me-1"></i> Add to Cart
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ))}
</div>

{/* Add this CSS to your global stylesheet for the hover effect */}
<style>{`
    .hover-shadow-transition {
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    .hover-shadow-transition:hover {
        transform: translateY(-3px);
        box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1) !important;
    }
`}</style>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
});